<template>
    <div>
        <div class="bg-white rounded">
            <h3 class="font-weight-bold px-3 f-20 pt-4 text-left mb-3 text-black">{{ $t('driverApp.title') }}</h3>
            <b-form class="pb-3 px-3">
                <b-row class="mt-2">
                    <b-col lg="7" md="12" sm="12">
                        <b-row class="mb-3">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.lockVehicle') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.applyNewDrivers') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].lock_vehicle" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.lockTrailer') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.applyNewDrivers') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].lock_trailer" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.allowDriverDocs') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.allowDriverDocsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].allow_driver_docs" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.allowVehicleDocs') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.allowVehicleDocsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].allow_vehicle_docs" name="check-button" switch
                                    size="lg" class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.allowTrailerDocs') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.allowTrailerDocsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].allow_trailer_docs" name="check-button" switch
                                    size="lg" class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.modelDocs') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.modelDocsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_model_docs" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.vehicle') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.vehicleDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_vehicle" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.trailer') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.trailerDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_trailer" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.company') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.companyDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_company" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.companyInfo') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.companyInfoDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].company_plus_info" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.documents') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.documentsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_documents" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between"
                                v-if="company && company[0].ai_docs">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.aiChat') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.aiChatDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_ai_chat" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12" v-if="company && company[0].ai_docs">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between"
                                v-if="company && company[0].show_hazmat_check">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.hazmatCheck') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.hazmatCheckDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].hazmat_check" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12" v-if="company && company[0].show_hazmat_check">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.contacts') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.contactsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].contacts" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.forms') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.formsDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_forms" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.fileDrop') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.fileDropDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showFileDrop" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>

                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.dotMode') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.dotModeDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_dot_mode" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between" v-if="showMaintenance">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.dvir') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.dvirDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].show_driver_dvir" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12" v-if="showMaintenance">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between"
                                v-if="company && company[0].show_safety">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.accident') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.accidentDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showAccidentSection" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12" v-if="company && company[0].show_safety">
                                <hr class="w-98 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between"
                                v-if="company && company[0].show_maintenance">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('driverApp.maintenance') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('driverApp.maintenanceDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showMaintenanceSection" name="check-button" switch size="lg"
                                    class="ml-0-6rem" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12" v-if="company && company[0].show_maintenance">
                                <hr class="w-98 mt-2 mb-0" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { checkValueExists } from "../../services/helper";
export default {
    name: "DriverApp",
    data() {
        return {
            checkValueExists,
            showMaintenance: false,
            showFileDrop: false,
            showAccidentSection: false,
            showMaintenanceSection: false,
            docTypeRequired: false
        }
    },
    methods: {
        ...mapActions(["updateCompany", 'setNotification', "getAllCountries", "setLoader"]),
        payloadToFormData(payload) {
            let formData = new FormData();
            for (let [key, value] of Object.entries(payload)) {
                if (key === "logo" && this.companyLogo) {
                    formData.append(key, this.companyLogo, this.companyLogo.name);
                } else if (key !== "logo") {
                    if (value !== null) {
                        formData.append(key, value);
                    }
                }
            }
            return formData;
        },
        async updateCompanyData() {
            try {
                this.setLoader(true)
                let companyData = {
                    ...this.company[0],
                    state: this.company[0].state.id,
                    show_file_drop: this.showFileDrop,
                    show_accident: this.showAccidentSection,
                    show_driver_maintenance: this.showMaintenanceSection,
                    doc_type: this.docTypeRequired,
                    company_id: this.userCompany
                };
                const formData = this.payloadToFormData(companyData);
                const updatedCompany = await this.updateCompany({
                    id: `${this.userCompany}`,
                    payload: formData,
                });
                if (updatedCompany) {
                    this.company[0] = updatedCompany;
                    await this.setNotification({
                        msg: this.$t('driverApp.updated', { name: this.company[0].name }),
                        type: "success",
                        color: "green",
                    });
                }
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
    computed: {
        ...mapGetters(['company', "userCompany", 'rolePermissions']),
        getEnterpriseStatus() {
            return (this.company[0]?.subscription?.type === 'Enterprise' && this.company[0]?.subscription?.status === 'active')
        },
        allowUpdateSettings() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'] && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
    },
    watch: {
        company: {
            async handler() {
                await this.$nextTick()
                this.showMaintenance = this.company[0].show_maintenance
                this.showFileDrop = this.company[0].show_file_drop
                this.showAccidentSection = this.company[0].show_accident
                this.showMaintenanceSection = this.company[0].show_driver_maintenance
                this.docTypeRequired = this.company[0].doc_type
            },
            immediate: true,
        }
    }
}
</script>